export default __webpack_public_path__ + "plugfones-alert.fa2a5a11.jpg";